import { render, staticRenderFns } from "./SimpleWithChild.vue?vue&type=template&id=ab3c9984&scoped=true"
import script from "./SimpleWithChild.vue?vue&type=script&lang=js"
export * from "./SimpleWithChild.vue?vue&type=script&lang=js"
import style0 from "./SimpleWithChild.vue?vue&type=style&index=0&id=ab3c9984&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3c9984",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab3c9984')) {
      api.createRecord('ab3c9984', component.options)
    } else {
      api.reload('ab3c9984', component.options)
    }
    module.hot.accept("./SimpleWithChild.vue?vue&type=template&id=ab3c9984&scoped=true", function () {
      api.rerender('ab3c9984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/rubricSetting/Add/components/SimpleWithChild.vue"
export default component.exports